<script lang="ts">
import {Component, Vue} from "vue-facing-decorator";
import NavBar from "@/component/common/NavBar.vue";
import SAEInfraComponent from "@/component/project/SAEInfraComponent.vue";

@Component({
  components: {
    SAEInfraComponent,
    NavBar
  },
})
export default class SAEInfraView extends Vue {
}
</script>

<template>
  <NavBar/>
  <div class="view-container">
    <SAEInfraComponent/>
  </div>
</template>

<style scoped>
.view-container {
  margin-left: 80px;
  height: 100vh;
  background-color: var(--background-color);
  padding: 20px;
  overflow-y: auto;
}
</style>